class GlobalJS {
  constructor() {
    this.init();
  }

  init() {
    console.log('Luxury365 Theme Loaded');
    this.handleScroll();
  }

  handleScroll() {
    // Placeholder for potential sticky header or scroll animations
    window.addEventListener('scroll', () => {
      document.body.style.setProperty('--scroll-y', window.scrollY);
    });
  }
}

new GlobalJS();
